import { USER_ROLES } from '@didaskill/domain/users/constants';
import type { MessageDescriptor } from '@didaskill/types/misc';

export enum SUBMISSION_STATUSES {
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED', // Equivalent to previous AWAITING_CORRECTION
  CORRECTION_IN_PROGRESS = 'CORRECTION_IN_PROGRESS',
  COMMENTED = 'COMMENTED',
  CORRECTED = 'CORRECTED',
}

export const ASSIGNMENT_MIN_GRADING_SCALE = 10;

export const ASSIGNMENT_MAX_GRADING_SCALE = 200;

export const ASSIGNMENT_DEFAULT_GRADING_SCALE = 20;

export const ASSIGNMENT_GRADING_STEP = 0.25;

export enum PATCH_ASSIGNMENT_SUBMISSIONS_ACTIONS {
  ALLOW_REDO = 'ALLOW_REDO',
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
}

export enum PATCH_ASSIGNMENT_SUBMISSIONS_DEPOSITS_ACTIONS {
  EVALUATION = 'EVALUATION',
  COMMENT = 'COMMENT',
}

export enum PATCH_STUDENT_ASSIGNMENT_SUBMISSION_ACTIONS {
  UPDATE = 'UPDATE',
  SUBMIT = 'SUBMIT',
  CORRECTION_SEEN = 'CORRECTION_SEEN',
}

export enum ASSIGNMENT_CORRECTOR_ROLES {
  MAIN = 'MAIN',
  SECONDARY = 'SECONDARY',
}

export enum ASSIGNMENT_ASSESSMENTS {
  VERY_SATISFACTORY = 'VERY_SATISFACTORY',
  SATISFACTORY = 'SATISFACTORY',
  UNSATISFACTORY = 'UNSATISFACTORY',
  VERY_UNSATISFACTORY = 'VERY_UNSATISFACTORY',
}

// In days
export const SUBMISSION_AVAILABLE_TO_SECONDARY_CORRECTOR = 7;

export const SUBMISSION_SCOPES = {
  [USER_ROLES.ANIMATION]: USER_ROLES.ANIMATION,
  [USER_ROLES.CORRECTOR]: USER_ROLES.CORRECTOR,
} as const;

export enum ASSIGNMENT_COMMENT_REASON {
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
  DEPOSIT_ISSUE = 'DEPOSIT_ISSUE',
  MISUNDERSTANDING_OF_INSTRUCTIONS = 'MISUNDERSTANDING_OF_INSTRUCTIONS',
  OTHER_REASON = 'OTHER_REASON',
}

export enum ASSIGNMENT_CORRECTION_KIND {
  COMMENT = 'ASSIGNMENT_CORRECTION_COMMENT',
  EVALUATION = 'ASSIGNMENT_CORRECTION_EVALUATION',
  MCQ = 'ASSIGNMENT_CORRECTION_MCQ',
}

export enum ASSIGNMENT_GRADE_VARIANT {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  DEFAULT = 'DEFAULT',
}

export enum ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS {
  ASSESSMENT_LOWEST = 'ASSESSMENT_LOWEST',
  ASSESSMENT_LOW = 'ASSESSMENT_LOW',
  ASSESSMENT_MEDIUM = 'ASSESSMENT_MEDIUM',
  ASSESSMENT_MEDIUM_HIGH = 'ASSESSMENT_MEDIUM_HIGH',
  ASSESSMENT_HIGH = 'ASSESSMENT_HIGH',
  ASSESSMENT_HIGHEST = 'ASSESSMENT_HIGHEST',
}

export const submissionAssessmentLabels: Record<ASSIGNMENT_ASSESSMENTS, MessageDescriptor> = {
  [ASSIGNMENT_ASSESSMENTS.VERY_SATISFACTORY]: {
    defaultMessage: 'Très satisfaisant',
  },
  [ASSIGNMENT_ASSESSMENTS.SATISFACTORY]: {
    defaultMessage: 'Satisfaisant',
  },
  [ASSIGNMENT_ASSESSMENTS.UNSATISFACTORY]: {
    defaultMessage: 'Insatisfaisant',
  },
  [ASSIGNMENT_ASSESSMENTS.VERY_UNSATISFACTORY]: {
    defaultMessage: 'Très insatisfaisant',
  },
};

export const studentTranscriptAssessmentLabels: Record<
  ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS,
  MessageDescriptor
> = {
  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_LOWEST]: {
    defaultMessage:
      'Le niveau est assez faible. Il est nécessaire de revoir les notions de cours non acquises !',
  },
  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_LOW]: {
    defaultMessage:
      'Un niveau assez juste. Persévérez dans le travail et les résultats augmenteront.',
  },

  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_MEDIUM]: {
    defaultMessage:
      'Ensemble correct, vous pouvez améliorer vos notes. Revoyez les notions qui ne sont pas maitrisées.',
  },

  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_MEDIUM_HIGH]: {
    defaultMessage: 'Résultats satisfaisants. Il faut continuer ainsi !',
  },

  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_HIGH]: {
    defaultMessage: 'Travail de qualité. Continuez dans cette voie pour réussir !',
  },

  [ASSIGNMENT_SUBMISSION_ASSESSMENT_LEVELS.ASSESSMENT_HIGHEST]: {
    defaultMessage:
      'Étudiant ayant de très bons résultats. La moyenne générale est très bonne. Continuez ainsi !',
  },
};
